import { render, staticRenderFns } from "./NewFooterItem.vue?vue&type=template&id=4ad51b54&scoped=true&"
import script from "./NewFooterItem.vue?vue&type=script&lang=ts&"
export * from "./NewFooterItem.vue?vue&type=script&lang=ts&"
import style0 from "./NewFooterItem.vue?vue&type=style&index=0&id=4ad51b54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad51b54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
